import React from 'react'
import Banner from "./banner/Banner"
import WhoWeAreSection from './who_we_are_section/WhoWeAreSection';
import AlumniPlaced from "./alumni_placed_swiper/AlumniPlaced"
import VisionMissionSection from './vision_mission_section/VisionMissionSection';
import CareerTrainingSection from "./career_training_section/CareerTrainingSection"
import Our_Programs from './our-programs/Our_Programs';
import Helped_Build from './helped-build/Helped_Build';
import Industry_Experts from '../home/industry-experts/Industry_Experts';
import Global_Big_Data from './global-big-data/Global_Big_Data';
import Carrer_Support_Team from './carrer-support-team/Carrer_Support_Team';
import Learn_Something_New from '../home/learn-something-new/Learn_Something_New';
import FAQ from '../explore-program/faq/FAQ';
import Pst_It_Solutions_FAQ from './pst_It_Solutions_FAQ/Pst_It_Solutions_FAQ';
import DirectorsMessage from './directorsMessage/DirectorsMessage';

function Pst_It_Solutions() {
  return (
    <section className='pst-it-solution-section'>
      <div>
        <Banner />
        <WhoWeAreSection />
        <DirectorsMessage/>
        <Industry_Experts />
        <Carrer_Support_Team />
        <AlumniPlaced />
        <VisionMissionSection />
        <CareerTrainingSection />
        <Our_Programs />
        <Helped_Build />
        <Global_Big_Data />
        <Learn_Something_New />
        <Pst_It_Solutions_FAQ />
      </div>
    </section>
  )
}

export default Pst_It_Solutions